import { userPokemonsType } from "./types";

const KEY = "pokedex:userPokemons";

export const loadLocalList = (): userPokemonsType[] => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const saveLocalList = (list: userPokemonsType[]): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // quota or privacy mode — best-effort, ignore
  }
};

export const clearLocalList = (): void => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};

// Merge by id, preferring the version from `local` when both have the same id.
// Used on sign-in to combine whatever the user added offline with whatever was
// already in Firestore.
export const mergeListsById = (
  remote: userPokemonsType[],
  local: userPokemonsType[]
): userPokemonsType[] => {
  const byId = new Map<number, userPokemonsType>();
  remote.forEach((p) => byId.set(p.id, p));
  local.forEach((p) => byId.set(p.id, p));
  return Array.from(byId.values());
};
